"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorWrapper = exports.AnchorContainer = exports.Anchor = exports.ReviewCart = exports.FooterContainer = exports.ReOpenOrderLabel = exports.Space = exports.CheckOut = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.CheckOut = styled_components_1.default.div `
  flex: 1;
`;
exports.Space = styled_components_1.default.div `
  width: 10px;
  height: 10px;
`;
exports.ReOpenOrderLabel = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: ${({ theme }) => theme.space.s100};

  color: ${({ theme }) => theme.colors.gray.s600};

  font-size: 0.9rem;

  ${({ theme }) => (0, styled_components_1.css)(theme.typography.body.smallText)};
`;
exports.FooterContainer = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.variables.breakpoints.tablet_portrait}) {
    flex-direction: column;
  }
`;
exports.ReviewCart = styled_components_1.default.div `
  position: relative;

  flex: 1;
`;
exports.Anchor = styled_components_1.default.a.attrs(() => ({
    onClick: (e) => {
        e.preventDefault();
    },
})) `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
exports.AnchorContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.variables.breakpoints.tablet_portrait}) {
    flex-direction: column;
  }
`;
exports.AnchorWrapper = styled_components_1.default.div `
  position: relative;

  display: flex;
  width: 100%;
`;
